import loggingService from '../services/util/loggingService'
import roleService from '../services/roleService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'userService'
var path = '/User/'
var isDebug = false

function validate (profile, roleList, companyList) {
    loggingService.log(isDebug, serviceName, 'validate')

    var result = {
        isValid: function () { return this.messageList.length === 0 },
        messageList: [] }

    validateRoleList(result, roleList)
    validateCompanyList(result, roleList, companyList)

    loggingService.log(isDebug, serviceName, 'result (next line)')
    loggingService.logRaw(isDebug, result)

    return result
}

function validateRoleList (result, roleList) {
    roleList = roleList || []
    if (roleList.length === 0) {
        addMessage(result, 'User has no roles assigned')
    }
}

function validateCompanyList (result, roleList, companyList) {
    roleList = roleList || []
    companyList = companyList || []

    validateCompanyListByRole(result, roleList, roleService.RoleEnum.ConsultantUser, companyList)
    validateCompanyListByRole(result, roleList, roleService.RoleEnum.BlmUser, companyList)
}

function validateCompanyListByRole (result, roleList, role, companyList) {
    if (hasRole(roleList, role)) {
        if (companyList.length === 0) {
            addMessage(result, 'User has role "' + role + '" assigned but no associated companies')
        }
    }
}

function addMessage (result, message) {
    result.messageList.push(message)
    result.isValid = false
}

function hasRole (roleList, role) {
    loggingService.log(isDebug, serviceName, 'hasRole, roleList: ' + roleList + ', role: ' + role)

    roleList = roleList || []
    role = role || ''

    var foundRole = _.find(roleList, function (item) {
        return item.toUpperCase() === role.toUpperCase()
    })

    return foundRole
}

// check if user's roleList matches any of the checkRoleList
function hasRoleCheck (userRoleList, checkRoleList) {
    if (userRoleList) {
        checkRoleList = checkRoleList || []
        var checkRoleListUpper = checkRoleList.map(role => role.toUpperCase())
        return userRoleList.some(role => {
            return checkRoleListUpper.includes(role.toUpperCase())
        })
    } else {
        return false
    }
}

function getCurrentShpoUserDto (http) {
    loggingService.log(isDebug, serviceName, 'GetCurrentShpoUserDto')

    return http.get(path + 'GetCurrentShpoUserDto')
}

function listAllUserResultDtos (http) {
    loggingService.log(isDebug, serviceName, 'ListAllUserResultDtos')

    return http.get(path + 'ListAllUserResultDtos')
}

function listAllShpoUsers (http) {
    loggingService.log(isDebug, serviceName, 'ListAllShpoUsers')

    return http.get(path + 'ListAllShpoUsers')
}

function put (http, userDto) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, userDto)
}

function sendVerifyEmail (http) {
    loggingService.log(isDebug, serviceName, 'SendVerifyEmail')
    return http.post(path + 'SendVerifyEmail')
}

function deleteNewUser (http, userId) {
    loggingService.log(isDebug, serviceName, 'deleteNewUser')
    return http.delete(path + '?userId=' + userId)
}

function listUserResultsByOrg (http, orgId) {
    loggingService.log(isDebug, serviceName, 'listUserResultsByOrg')
    return http.get(path + 'ListUserResultsByOrg?orgId=' + orgId)
}

function searchUserResultDtos (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'SearchUserResultDtos')

    return http.post(path + 'SearchUserResultDtos', searchDto)
}

export default {
    validate: validate,
    hasRole: hasRole,
    hasRoleCheck: hasRoleCheck,
    getCurrentShpoUserDto: getCurrentShpoUserDto,
    listAllUserResultDtos: listAllUserResultDtos,
    listAllShpoUsers: listAllShpoUsers,
    put: put,
    sendVerifyEmail: sendVerifyEmail,
    deleteNewUser: deleteNewUser,
    listUserResultsByOrg: listUserResultsByOrg,
    searchUserResultDtos: searchUserResultDtos
}



// WEBPACK FOOTER //
// ./src/services/userService.js